export const ADMIN = 1;
export const TEACHER = 2;
export const STUDENT = 3;
export const SCHOOL = 4;

export const ROLE_MAP = {
  [STUDENT]: "student",
  [ADMIN]: "admin",
  [TEACHER]: "teacher",
  [SCHOOL]: "school",
};
